import React, { useEffect } from 'react';
import styles from './styles.module.css';
import infoCircle from 'assets/info-circle.svg';
import { useSelector, useDispatch } from 'react-redux';
import useMessages from 'hooks/useMessages';
import * as Types from 'helpers/types';

const BannerMessage = () => {
  const dispatch = useDispatch();
  const { messages } = useSelector((state) => state);
  const [getMessages] = useMessages();

  useEffect(() => {
    async function wrappedGetMessages() {
      try {
        dispatch({ type: Types.MESSAGES_LOADING });
        const messagesData = await getMessages();
        dispatch({ type: Types.MESSAGES_SUCCESS, payload: messagesData });
      } catch (e) {
        dispatch({ type: Types.MESSAGES_ERROR, payload: e });
      }
    }

    wrappedGetMessages();
  }, []);

  if (messages.loading || messages.error) return null;
  const { bannerMessages } = messages;

  if (bannerMessages) {
    return bannerMessages.map((msg) => (
      <div key={msg} className={styles.infoContainer}>
        <div className={styles.infoContainer__header}>
          <img className={styles.infoContainer__icon} src={infoCircle} alt="Info Circle" />
          <h2 className={styles.infoContainer__heading}>Update</h2>
        </div>
        <div>
          <p
            className={styles.infoContainer__paragraph}
            dangerouslySetInnerHTML={{
              __html: msg,
            }}
          />
        </div>
      </div>
    ));
  } else return null;
};

export default BannerMessage;
